import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

export const fetchDailyPOSWithCombo = createAsyncThunk(
  "api/dailyPOS/fetch",
  async (
    {
      fromDate,
      toDate,
      branche_ids = [],
      product_ids = [],
      group_by = "daily", // group by: daily - weekly - monthly - yearly
      valueType = "total", // value Type: total - tax - withTax
      viewType = "all", // value Type: all - customers - item - salesman
      foodDeliveryApp = 0, // foodDeliveryApp: 0 - 1 (0 for None POS, 1 for Toyou)
      atvEnabled = false, // atvEnabled: true/false for ATV calculation
      comboID = 0,
      comboOnly = false,
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState();
      let pos_ids = branche_ids;
      if (branche_ids.length > 0) {
        branche_ids = branche_ids.map(Number);
        const allGroups = state.POSBranches?.rows || [];

        const matchedChildren = allGroups.flatMap(
          (group) =>
            group.children?.filter((child) =>
              branche_ids.includes(child.realId)
            ) || []
        );
        pos_ids = matchedChildren
          .map((child) => {
            const odooId = Number(child.res_branch_id);
            if (odooId) return odooId;
            const rmsId = Number(child.realId);
            return rmsId ? -rmsId : null;
          })
          .filter((id) => id != null && id !== 0);
      }

      const requestData = {
        fromdate: fromDate,
        todate: toDate,
        branche_ids: pos_ids,
        product_ids,
        group_by,
        valueType,
        viewType,
        foodDeliveryApp,
        atvEnabled,
        comboID,
        comboOnly,
      };

      const response = await api.post(`/api/DailyPOSWithCombo`, requestData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const dailyPOSWithComboSlice = createSlice({
  name: "dailyPOS",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyPOSWithCombo.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDailyPOSWithCombo.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload;
      })
      .addCase(fetchDailyPOSWithCombo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default dailyPOSWithComboSlice.reducer;

// Selectors
export const selectDailyPOSWithComboRows = (state) => state.dailyPOS.rows;
export const selectDailyPOSWithComboStatus = (state) => state.dailyPOS.status;
export const selectDailyPOSWithComboError = (state) => state.dailyPOS.error;
